export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Updates', href: '/updates' },
  { label: 'Market', href: '/market' },
];
